import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useApp } from "@/context/AppContext";
import { PageHeader } from "@/components/kit";
import { Employees } from "@/components/payroll/Employees";
import { Runs } from "@/components/payroll/Runs";
import { Cnss, PayrollSettings } from "@/components/payroll/Cnss";
import { Leaves } from "@/components/payroll/Leaves";

const TABS = { runs: Runs, employees: Employees, leaves: Leaves, cnss: Cnss, settings: PayrollSettings };

export default function Payroll() {
  const { t } = useApp();
  const [tab, setTab] = useState("runs");
  const C = TABS[tab];
  return (
    <>
      <PageHeader eyebrow={t("payroll_eyebrow")} title={t("payroll")} />
      <Tabs value={tab} onValueChange={setTab}>
        <TabsList className="bg-white border">{Object.keys(TABS).map((k) => <TabsTrigger key={k} value={k} data-testid={`payroll-tab-${k}`}>{t(`payroll_tab_${k}`)}</TabsTrigger>)}</TabsList>
      </Tabs>
      <C />
      <p className="text-xs text-slate-500">{t("payroll_disclaimer")}</p>
    </>
  );
}
